import { Typography, Table, Avatar } from 'antd'
import { DateTime } from 'luxon'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Spinner from '../../components/Spinner'
import { getAllAchievements } from '../../reducers/achievementsReducer'

const { Title } = Typography
const { Column } = Table

const Achievements = (props) => {
  const dispatch = useDispatch()

  const achievements = useSelector((state) => state.achievements.data)
  const loading = useSelector((state) => state.achievements.loading)

  useEffect(() => {
    dispatch(getAllAchievements())
  }, [])

  if (loading) return <Spinner size="large" />

  return (
    <div style={{ width: '100%', minWidth: 0, overflow: 'hidden' }}>
      <Title level={3} style={{ marginBottom: 0 }}>Achievements</Title>

      <div style={{ overflowX: 'auto', marginTop: 16, WebkitOverflowScrolling: 'touch' }}>
        <Table
          pagination={false}
          rowKey={(achievement) => achievement.id || `${achievement.user?.id}-${achievement.course?.id}`}
          dataSource={achievements}
          scroll={{ x: 'max-content' }}
          style={{ minWidth: 520 }}
        >
        <Column
          title="Photo"
          dataIndex={['user', 'photo']}
          render={(img) => <Avatar src={img} />}
        />
        <Column title="Course Name" dataIndex={['course', 'name']} />
        <Column
          title="Finished At"
          dataIndex="finishedAt"
          render={(time) => {
            if (!time) return '-'
            else
              return DateTime.fromISO(time).toLocaleString(
                DateTime.DATETIME_MED
              )
          }}
        />

        <Column
          title="Grade"
          dataIndex="gradeLetter"
          render={(grade) => {
            if (!grade) return '-'
            else return grade
          }}
        />
        <Column
          title="Certificate"
          dataIndex="certificate"
          render={(certificate) => {
            if (!certificate) return '-'
            else return <a href={`${certificate}`}>certificate</a>
          }}
        />
      </Table>
      </div>
    </div>
  )
}

export default Achievements
